// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:1920px){.col-xl-4[data-v-5bacf71b]{min-width:450px}}", ""]);
// Exports
module.exports = exports;
